import { MESSAGES_COPY } from '../messages/COPY';
import { PLACEHOLDERS_COPY } from '../placeholders/COPY';

export const STAKEHOLDER_NAME = {
	MAX_LENGTH: 55,
	MIN_LENGTH: 2,
	PATTERN: /^[a-zA-Z0-9, ',~`-]+$/u,
	PLACEHOLDER: PLACEHOLDERS_COPY.STAKEHOLDER_NAME,
	REQUIRED_MESSAGE: MESSAGES_COPY.PLEASE_ENTER_A_STAKEHOLDER_NAME
};
